import React, { useId } from 'react';
import { Link } from 'react-router-dom';
type ConsentCheckboxProps = {
  name?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  error?: string;
  tone?: 'light' | 'dark';
  children?: React.ReactNode;
};
export function ConsentCheckbox({
  name = 'consent',
  checked,
  onChange,
  error,
  tone = 'light',
  children
}: ConsentCheckboxProps) {
  const id = useId();
  const text = tone === 'dark' ? 'text-white/75' : 'text-muted';
  const link = tone === 'dark' ? 'text-gold-300' : 'text-royal';
  return <div data-id="element-490" data-mp="1y2i5vao9umhn">
      <div className="flex items-start gap-3" data-id="element-491" data-mp="1y2qhz0cklnrs">
        <input id={id} name={name} type="checkbox" checked={checked} onChange={e => onChange(e.target.checked)} aria-invalid={error ? true : undefined} aria-describedby={error ? `${id}-err` : undefined} className="mt-0.5 h-4 w-4 shrink-0 cursor-pointer rounded border-line accent-[#0A1426]" data-id="element-492" data-mp="2cqbnf0wx3z2v" />
        <label htmlFor={id} className={`cursor-pointer text-sm leading-relaxed ${text}`} data-id="element-493" data-mp="17uo747jf0xf8">
          {children ?? <>
              I have read the{' '}
              <Link to="/legal/privacy" className={`underline underline-offset-2 ${link}`} data-id="element-494" data-mp="1crwldx1g0hb7">
                privacy notice
              </Link>{' '}
              and agree to Corventa processing my details to respond to this request.
            </>}
        </label>
      </div>
      {error && <p id={`${id}-err`} className={`mt-1.5 text-sm ${tone === 'dark' ? 'text-red-300' : 'text-danger'}`} data-id="element-495" data-mp="oxvd292fbsju">
          {error}
        </p>}
    </div>;
}